/*
 *   File : gold.js
 *   Author : https://evoqins.com
 *   Description : Gold tab data component
 *   Integrations : NA
 *   Version : 1.0.0
*/

// packages
import React from 'react';
import { BasketCard } from '../../../Components/Card';

const Gold = (props) => {
    return (
        <div className='pt-4'>
            {props.basketData.basket.map((data, key) => (
                <div key={key} className='col-6'>
                    <BasketCard basketData={data}
                        selectedTab={props.selectedTab}
                        type={3}
                        handleRebalance={() => props.handleRebalance(data)} />
                </div>
            ))}
        </div>
    )
}

export default Gold;